export enum AccountType {
    INDIVIDUALACCOUNT = 0,
    SSO = 1
}

export enum AccountTypeNameEnum {
    INDIVIDUALACCOUNT = "Individual account",
    SSO = "Single Sign-On (SSO)"
}

export enum NetcoreUserEmailEnum {
    NETCORECLOUD_COM = "@netcorecloud.com",
    HANSEL_IO = "@hansel.io"
}